/* eslint-disable react/style-prop-object */
import "./index.css";
import "./Component/tablecomponents.css";
import "../Product/index.css";
import "../CompanyDetail2/index.css";
import "../CompanyDetail/index.css";
import { useState, useEffect, useCallback, createContext } from "react";
import Delete from "../../components/Option/Delete";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { deleteProduct } from "../../apis/Product";
import { AlertV2 } from "../../components/Alert";
import { useTranslation } from "react-i18next";
import { ContainerBody } from "../../App";
import { getProductSummary } from "../../apis/ARDash/ProductSummary";
import { NewProductDetail } from "../NewProductDetail";
import { ProductDetailView } from "../NewProductCategories/ProductDetails";
import YFSLabelProductDetail from "../NewProductDetail/YFSLabelProductDetail";
import Sidebar from "../NewProductCategories/Sidebar";
import {
  GeneratePagePDFProduct,
  GeneratePagePDFProductAlternative,
} from "../../components/GeneratePDF/GeneratePDFProduct";
import { useBonsaiPreload } from "../../hooks/useBonsaiData";

export const DropdownInventoriesContext = createContext();

const ProductDetail = () => {
  const [showCategory, setShowCategory] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const [chosen, setChosen] = useState("E");
  const [productSummaryData, setProductSummaryData] = useState([]);
  const [deleteProductAlert, setDeleteProductAlert] = useState(false);

  // Preload Bonsai data as soon as user enters product section
  useBonsaiPreload();

  // PDF generation states
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
  const [pdfProgress, setPdfProgress] = useState("");
  const [pdfMethod, setPdfMethod] = useState("alternative"); // "optimized" or "alternative"

  let { productId } = useParams();
  const business = queryParams.get("business");

  useEffect(() => {
    if (window.location.href.includes("product")) {
      getProductSummary({
        id: productId,
        business: business,
        setObjects: setProductSummaryData,
      });
    }
  }, [business, productId]);

  const { t } = useTranslation();

  const handleDelete = () => {
    setDeleteProductAlert(true);
  };

  const navigate = useNavigate();
  const handleMove = useCallback(
    () => navigate("/product", { replace: true }),
    [navigate]
  );

  // Enhanced PDF Generation Handler
  const handleGeneratePDF = async () => {
    setIsGeneratingPDF(true);
    setPdfProgress("Initializing PDF generation...");

    try {
      const generateFunction =
        pdfMethod === "alternative"
          ? GeneratePagePDFProductAlternative
          : GeneratePagePDFProduct;

      const result = await generateFunction({
        filename: `product-detail-${productId}-${
          new Date().toISOString().split("T")[0]
        }.pdf`,
        onProgress: setPdfProgress,
        quality: 0.8,
        format: "a4",
        maxHeight: 2500,
      });

      if (result.success) {
        setPdfProgress(
          `PDF generated successfully! (${result.pageCount} pages)`
        );
        setTimeout(() => {
          setPdfProgress("");
          setIsGeneratingPDF(false);
        }, 3000);
      } else {
        throw new Error(result.error);
      }
    } catch (error) {
      console.error("PDF generation error:", error);

      if (pdfMethod === "optimized") {
        setPdfProgress("Retrying with alternative method...");
        setPdfMethod("alternative");

        try {
          const result = await GeneratePagePDFProductAlternative({
            filename: `product-detail-${productId}-${
              new Date().toISOString().split("T")[0]
            }.pdf`,
            onProgress: setPdfProgress,
            quality: 0.6,
            format: "a4",
          });

          if (result.success) {
            setPdfProgress(
              `PDF generated successfully! (${result.pageCount} pages)`
            );
            setTimeout(() => {
              setPdfProgress("");
              setIsGeneratingPDF(false);
            }, 3000);
            return;
          }
        } catch (alternativeError) {
          console.error(
            "Alternative PDF generation also failed:",
            alternativeError
          );
        }
      }

      setPdfProgress(
        "Failed to generate PDF. Please try refreshing the page and trying again."
      );
      setTimeout(() => {
        setPdfProgress("");
        setIsGeneratingPDF(false);
      }, 5000);
    }
  };

  return (
    <>
      <Sidebar />
      <ContainerBody className="product__body">
        {/* Move NewProductDetail inside ContainerBody to include it in PDF */}
        <NewProductDetail showCategory={showCategory} />

        {/* Enhanced PDF Generation Controls */}
        <div
          className="pdf-controls"
          style={{
            padding: "10px 20px",
            backgroundColor: "#f8f9fa",
            borderBottom: "1px solid #dee2e6",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "10px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <button
              onClick={handleGeneratePDF}
              disabled={isGeneratingPDF}
              style={{
                padding: "8px 16px",
                backgroundColor: isGeneratingPDF ? "#6c757d" : "#007bff",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: isGeneratingPDF ? "not-allowed" : "pointer",
                fontSize: "14px",
                minWidth: "140px",
              }}
            >
              {isGeneratingPDF ? "Generating PDF..." : "Generate PDF"}
            </button>
          </div>

          {pdfProgress && (
            <div
              style={{
                fontSize: "14px",
                color: pdfProgress.includes("Failed")
                  ? "#dc3545"
                  : pdfProgress.includes("successfully")
                  ? "#28a745"
                  : "#007bff",
                fontWeight: "500",
                maxWidth: "400px",
              }}
            >
              {pdfProgress}
            </div>
          )}
        </div>

        <div className="eorsorg__body" style={{ marginTop: "10px" }}>
          <div
            className={
              "eorsorg__each " + (chosen === "E" ? "eorsorg__chosen" : "")
            }
            onClick={() => setChosen("E")}
          >
            <h3 className="mb-2">E</h3>
            <h5 className="mb-2">Environment</h5>
          </div>
          <div
            className={
              "eorsorg__each " + (chosen === "S" ? "eorsorg__chosen" : "")
            }
            onClick={() => setChosen("S")}
          >
            <h3 className="mb-2">S</h3>
            <h5 className="mb-2">Social</h5>
            {chosen === "S" ? (
              <h6>
                In this section we dive into everything there is concerning
                people in your organisation and from your suppliers towards your
                clients. Starting with basic data employees
              </h6>
            ) : null}
          </div>
          <div
            className={
              "eorsorg__each " + (chosen === "G" ? "eorsorg__chosen" : "")
            }
            onClick={() => setChosen("G")}
          >
            <h3 className="mb-2">G</h3>
            <h5 className="mb-2">Governance</h5>
            {chosen === "G" ? (
              <h6>
                The purpose of this section is to dive into where the company in
                the governance structure can support everything from prevention
                of whitewash scandals to diversity in the board and management
              </h6>
            ) : null}
          </div>
        </div>

        {chosen === "E" && (
          <ProductDetailView
            showCategory={showCategory}
            setShowCategory={setShowCategory}
          />
        )}

        <div style={{ paddingRight: "30px" }}>
          <YFSLabelProductDetail productData={productSummaryData} />
        </div>

        <div className="productdetail__wrapper">
          <div className="productdetail__option">
            <Delete
              header={t("DELETE_PRODUCT")}
              style={"product"}
              click={handleDelete}
            />
          </div>
        </div>
      </ContainerBody>

      <AlertV2
        open={deleteProductAlert}
        title={t("DELETE_PRODUCT_2")}
        accept={() => {
          deleteProduct({ id: productId, business: business });
          handleMove();
        }}
        decline={() => setDeleteProductAlert(false)}
      />

      {/* PDF Generation Overlay */}
      {isGeneratingPDF && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 10000,
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "30px",
              borderRadius: "8px",
              textAlign: "center",
              maxWidth: "400px",
            }}
          >
            <div
              style={{
                width: "40px",
                height: "40px",
                border: "4px solid #f3f3f3",
                borderTop: "4px solid #007bff",
                borderRadius: "50%",
                animation: "spin 1s linear infinite",
                margin: "0 auto 20px",
              }}
            />
            <h4 style={{ marginBottom: "10px", color: "#333" }}>
              Generating PDF...
            </h4>
            <p style={{ color: "#666", fontSize: "14px" }}>
              {pdfProgress || "Please wait while we prepare your PDF"}
            </p>
          </div>
        </div>
      )}

      {/* Add spinning animation CSS */}
      <style jsx>{`
        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </>
  );
};
export default ProductDetail;
